/**
 * Punkt 8 vom 14.09.2026 (Durchsprache, `35.1-REVIEW.md`): Mantines `NumberInput` liefert eine
 * gueltige Eingabe als `number` an `onChange` (`floatValue`,
 * `@mantine/core/esm/components/NumberInput/NumberInput.mjs`, `handleValueChange`).
 * `ValidatedNumberInput` speichert dezimale Felder als `String(val)` -- und JavaScript schreibt
 * Zahlen unter 1e-6 in Exponentenschreibweise (`String(5e-7) === '5e-7'`). Mit `decimalScale: 4`
 * war dieser Bereich nicht eintippbar; mit `decimalScale: 7` (`EMISSION_INPUT_PROPS`) ist er es
 * (0,0000001 bis 0,0000009). Ohne diese Umwandlung stuende `5e-7` in Formular, Matrix und Payload.
 *
 * Fuer alle anderen Werte bleibt die Ausgabe identisch zu `String(value)` -- diese Funktion
 * AENDERT NUR Werte, deren `String()`-Darstellung eine Exponentenschreibweise ergibt.
 */
export function toDecimalString(value: number | string, decimalScale?: number): string {
  if (typeof value === 'string') return value;

  const text = String(value);
  if (!/e/i.test(text)) return text;

  const fixed = value.toFixed(Math.min(decimalScale ?? 20, 100));
  // Nachgestellte Nullen NUR im Nachkommateil entfernen -- "10" darf nicht zu "1" werden.
  if (!fixed.includes('.')) return fixed;
  return fixed.replace(/0+$/, '').replace(/\.$/, '');
}
